module.exports = __webpack_public_path__ + "static/media/hotspot_text_atlas.fc85d923.png";